module.exports = __webpack_public_path__ + "static/media/ie.357c8b34.svg";